// eslint-disable-next-line no-unused-vars
import { State, Actions } from 'shared/types';
import ACTION_TYPE from 'shared/constants/actionTypes';

export default (state: State, action: Actions) => {
  // console.log('statestate', state, action);
  switch (action.type) {
    case ACTION_TYPE.GET_DASHBOARD_SUMMARY:
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          summary: action.payload,
        },
      };
    case ACTION_TYPE.GET_LANGUAGE:
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          languageRemote: action.payload,
        },
      };
    case ACTION_TYPE.SELECT_ITEM:
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          summary: action.payload.summary,
          detail: action.payload.detail,
        },
      };
    case ACTION_TYPE.UPDATE_CLIENT_DATA:
      return {
        ...state,
        rootState: {
          ...state.rootState,
          clientData: {
            ...state.rootState.clientData,
            [action.payload.key]: action.payload.value,
          },
        },
      };
    case ACTION_TYPE.CLEAR_CLIENT_DATA:
      return {
        ...state,
        rootState: {
          ...state.rootState,
          clientData: action.payload,
        },
      };
    default:
      return state;
  }
};
